import React from 'react';
import { colors } from '@styleseat/brand';
import type { PublicProvider } from '../../../../../api/Providers';
import {
  BodyText,
  HeaderText,
  Stack,
  Skeleton,
} from '../../../../ui';
import Address from '../../Address';
import StaticMap from '../../StaticMap';
import { ClientProviderProfile } from '../../../../../api/ProfileClientView';
import { getBusinessName, getProfileLocation } from '../../../../../api/ProfileClientView/ProfileClientView';

type ProBusinessInfoCardProps = {
  provider: PublicProvider | ClientProviderProfile;
  businessHours: React.ReactNode;
  cancellationPolicy: React.ReactNode;
  depositPolicy: React.ReactNode;
  contactActions: React.ReactNode;
  locationAction?: React.ReactNode;
  onPressMap: () => void;
  showMap?: boolean;
  showLocationInstructions?: boolean;
};

export const ProBusinessInfoCard: React.FCWithChildren<ProBusinessInfoCardProps> = ({
  provider,
  businessHours,
  cancellationPolicy,
  depositPolicy,
  onPressMap,
  contactActions,
  locationAction,
  showMap,
  showLocationInstructions,
}) => {
  const location = getProfileLocation(provider);
  const businessName = getBusinessName(provider);
  const {
    address1,
    address2,
    city,
    state,
    location_instructions,
    mobile_business,
  } = location || {};

  return (
    <Stack
      testID="pro-business-info-card"
      color={colors.whiteWash}
      borderWidth={1}
      borderColor={colors.lightGrey}
      borderStyle="solid"
      space={8}
    >
      {
        showMap ? (
          <StaticMap
            onPress={onPressMap}
            profile={provider}
          />
        ) : (<Stack space={16} alignItems="center"> <Skeleton /> </Stack>
        )
      }

      <Stack space={16} paddingX={12} paddingY={20}>
        <Stack space={4}>
          <HeaderText level={4}>Contact</HeaderText>
          <BodyText>{businessName}</BodyText>
          <Address
            address1={address1}
            address2={address2}
            city={city}
            state={state}
            locationInstructions={showLocationInstructions ? location_instructions : undefined}
            mobileBusiness={mobile_business}
            inline
          />
          {locationAction}
        </Stack>

        {contactActions}
        {businessHours}
        {depositPolicy}
        {cancellationPolicy}
      </Stack>
    </Stack>
  );
};

ProBusinessInfoCard.defaultProps = {
  showMap: true,
};

export default ProBusinessInfoCard;
